import { Component, Inject, OnInit } from '@angular/core';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { ALERTS } from 'src/app/common';
import { IPermission, IRole } from 'src/app/models';
import { AlertsService } from 'src/app/services/alerts.service';
import { PermissionService } from 'src/app/services/permission.service';
import { RoleService } from 'src/app/services/role.service';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faArrowLeft, faArrowRight, faEdit } from '@fortawesome/free-solid-svg-icons';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-premissions',
  templateUrl: './premissions.component.html',
  styleUrls: ['./premissions.component.css']
})
export class PremissionsComponent implements OnInit {

  roles: IRole[];
  asigPermissions: IPermission[];
  disPermissions: IPermission[];
  permissions: IPermission[];

  selectedRole!: IRole;

  modalReference: NgbModalRef;
  RoleForm: FormGroup;

  constructor(
    private roleService: RoleService,
    private permissionService: PermissionService,
    private alertsService: AlertsService,
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    library: FaIconLibrary
  ) {
    library.addIcons(faArrowLeft, faArrowRight, faEdit)
    this.roles = [];
    this.asigPermissions =[];
    this.disPermissions = [];
    this.permissions = [];
  }

  ngOnInit(): void {
    this.ResetRoleForm();
    this.onLoad();
  }

  drop(event: CdkDragDrop<IRole[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
                        event.container.data,
                        event.previousIndex,
                        event.currentIndex);
      this.updateRolePermissions();
    }
  }

  onLoad() {
    this.loadRoles();
    this.loadPermissions();
  }

  active(role: IRole){
    if(!this.selectedRole) return false
    return (this.selectedRole == role)
  }

  loadRoles(){
    this.roleService.GetRoles().subscribe(res => {
      if(res.Result){
        this.roles = res.Data;
        if(this.roles.length > 0) this.updateRoleSelection(this.roles[0])
      }
    },
    err => {
      this.alertsService.ShowSmallCornerAlert(err, ALERTS.error)
    })
  }

  loadPermissions(){
    this.permissionService.GetPermissions().subscribe(res => {
      if(res.Result){
        this.permissions = [];
        res.Data.forEach(x => { if(x.Active) this.permissions.push(x)})
      }
    },
    err => {
      this.alertsService.ShowSmallCornerAlert(err, ALERTS.error)
    })
  }

  loadPermissionsByRole(role: IRole){
    if(role){
      this.permissionService.GetPermissionsByRole(role).subscribe(res => {
        if(res.Result){
          this.asigPermissions = [];
          this.disPermissions = [];
          this.permissions.forEach(x => {
            if(res.Data.find(y => y.PermissionId == x.Id)) this.asigPermissions.push(x)
            else this.disPermissions.push(x)
          })
        }
      },
      err => {
        this.alertsService.ShowSmallCornerAlert(err, ALERTS.error)
      })
    }
  }

  updateRolePermissions(){
    let permissionIds = this.asigPermissions.map(x => x.Id)
    this.permissionService.UpdatePermissionsByRole(permissionIds, this.selectedRole.Id)
    .subscribe(
      res => {
        if(res.Result) this.alertsService.ShowSmallCornerAlert('Permisos actualizados', ALERTS.success)
        else this.alertsService.ShowSmallCornerAlert(res.ErrorInfo.Message, ALERTS.error)
      },
      err => {
        this.alertsService.ShowSmallCornerAlert(err, ALERTS.error)
    });
  }

  clearSelectedUser(){
    this.selectedRole = undefined as any;
    this.asigPermissions = [];
    this.disPermissions = [];
  }


  updateRoleSelection(role: IRole){
    this.selectedRole = role;
    this.loadPermissionsByRole(this.selectedRole)
  }

  setAllPermissions(){
    this.asigPermissions = this.asigPermissions.concat(this.disPermissions.splice(0, this.disPermissions.length))
    this.updateRolePermissions();
  }

  unsetAllPermissions(){
    this.disPermissions = this.disPermissions.concat(this.asigPermissions.splice(0, this.asigPermissions.length))
    this.updateRolePermissions();
  }

  ResetRoleForm(): void {
    this.RoleForm = this.formBuilder.group({
      Id: [-1],
      Name: ['', Validators.required],
      Code: ['', Validators.required],
      Active: [false, Validators.required]
    });
  }

  RaiseModal(content: any): void {
    this.modalReference = this.modalService.open(content,
      {
        centered: true,
        backdrop: 'static'
      });
  }

  CloseModal(): void {
    this.modalReference.close();
  }

  StoreRole(){
    if(this.RoleForm.valid){
      let Role = this.RoleForm.value as IRole;
      this.roleService.StoreRole(Role).subscribe(req => {
        if(req.Result){
          this.CloseModal();
          this.loadRoles();
          this.alertsService.ShowSmallCornerAlert("Rol guardado con éxito", 1)
        } else {
          this.alertsService.ShowSmallCornerAlert(req.ErrorInfo.Message, 2)
        }
      }, err => {
        this.alertsService.ShowSmallCornerAlert(err, 3)
      })
    } else {
      this.alertsService.ShowBigCenteredAlert("Todos los campos son requeridos", 3)
    }
  }

  NewRole(content){
    this.ResetRoleForm();
    this.RaiseModal(content);
  }

  EditRole(content: any, Role: IRole){
    this.RoleForm.patchValue({
      ...Role
    });
    this.RaiseModal(content);
  }

}
